$s.DateCalculator = {
  /**
   * Returns the Monday of the week containing dateStr.
   */
  getMondayOfWeek: function (startDate) {
    const [y, m, d] = startDate.split('-').map(Number);
    const date = new Date(y, m - 1, d);

    const day = date.getDay(); // 0=Sun 1=Mon … 6=Sat
    const daysSinceMonday = day === 0 ? 6 : day - 1;

    const monday = new Date(date);
    monday.setDate(date.getDate() - daysSinceMonday);

    const yy = monday.getFullYear();
    const mm = String(monday.getMonth() + 1).padStart(2, '0');
    const dd = String(monday.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
  },
  /**
  * Mon–Thu: Monday of the same week, Fri–Sun: Monday of the following week.
  */
  getStartingMonday: function (startDate) {
    const [y, m, d] = startDate.split('-').map(Number);
    const date = new Date(y, m - 1, d);

    const day = date.getDay();
    const useNextWeek = day === 0 || day >= 5;
    const daysSinceMonday = day === 0 ? 6 : day - 1;

    const monday = new Date(date);
    monday.setDate(date.getDate() - daysSinceMonday);
    if (useNextWeek) monday.setDate(monday.getDate() + 7);

    const yy = monday.getFullYear();
    const mm = String(monday.getMonth() + 1).padStart(2, '0');
    const dd = String(monday.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
  },
  /**
  *  Date format: YYYY-MM-DD
  *   %Weekday: full weekday name
  *   %Month: full month name
  *   %YYYY: 4-digit year
  *   %Mon: abbreviated month
  *   %Day: abbreviated weekday
  *   %DD: zero-padded day (01–31)
  *   %MM: zero-padded month (01–12)
  *   %YY: 2-digit year
  *   %D: day without padding
  *   %M: month without padding
  */
  getDateMessage: function (template, dateStr) {
    const [y, mo, d] = dateStr.split('-').map(Number);
    const date = new Date(y, mo - 1, d);

    const fmt = (opts) => new Intl.DateTimeFormat(this.isoCode, opts).format(date);

    // Tokens ordered longest-first so e.g. %Month is replaced before %M.
    const tokens = [
      ['%Weekday', fmt({ weekday: 'long'  })],
      ['%Month',   fmt({ month:   'long'  })],
      ['%YYYY',    String(date.getFullYear())],
      ['%Mon',     fmt({ month:   'short' })],
      ['%Day',     fmt({ weekday: 'short' })],
      ['%DD',      String(d).padStart(2, '0')],
      ['%MM',      String(mo).padStart(2, '0')],
      ['%YY',      String(date.getFullYear()).slice(-2)],
      ['%D',       String(d)],
      ['%M',       String(mo)],
    ];

    return tokens.reduce((msg, [token, value]) => msg.replaceAll(token, value), template).replace('[b]', '<strong>').replace('[/b]', '</strong>');
  },
  getEstimatedShippingDate: function (startDate, { leadTime = 0, bufferDays = 0, additionalDays = 0 } = {}) {
    const [y, m, d] = startDate.split('-').map(Number);
    const date = new Date(y, m - 1, d);
    date.setDate(date.getDate() + leadTime + bufferDays + additionalDays);

    const todayMs = new Date(this.today).getTime();
    if (date.getTime() <= todayMs) return this.today;

    const yy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yy}-${mm}-${dd}`;
  },
  isValidWearDate: function (estimatedShippingDate, wearDate, safetyDays = 0) {
    const toMs = (str) => {
      const [y, m, d] = str.split('-').map(Number);
      return new Date(y, m - 1, d).getTime();
    };
    return toMs(wearDate) >= toMs(estimatedShippingDate) + safetyDays * 864e5;
  }
}

$s.validateWearDatesInJson = async function(items) {
  const checkHasValidWearDate = (properties) => {
    const {
      _wear_date: wearDate,
      _lead_time,
      _buffer_days,
      _safety_days,
    } = properties;


    let adjustLeadTime = 0;
    if (Object.hasOwn(properties, '_adjust_lead_time')) {
      adjustLeadTime = properties._adjust_lead_time != "" && !Number.isNaN(Number(properties._adjust_lead_time)) ?
        parseInt(properties._adjust_lead_time) : 0
    }

    let adjustBufferDays = 0;
    if (Object.hasOwn(properties, '_adjust_buffer_days')) {
      adjustBufferDays = properties._adjust_buffer_days != "" && !Number.isNaN(Number(properties._adjust_buffer_days)) ?
        parseInt(properties._adjust_buffer_days) : 0
    }
    const leadTime = parseInt(_lead_time) + adjustLeadTime;
    const bufferDays = parseInt(_buffer_days) + adjustBufferDays;
    const safetyDays = parseInt(_safety_days);
    if (!wearDate) return false;

    const today = new Date().toISOString().slice(0, 10);
    const startShippingDate = $s.DateCalculator.getStartingMonday(today);
    const estimatedShippingDate = $s.DateCalculator.getEstimatedShippingDate(startShippingDate, {
      leadTime,
      bufferDays,
    });

    const isValidDate = $s.DateCalculator.isValidWearDate(estimatedShippingDate, wearDate, safetyDays)
    return !isValidDate;
  }

  const updates = items
    .filter(item => item.properties && Object.hasOwn(item.properties, '_wear_date'))
    .filter(item => checkHasValidWearDate(item.properties))
    .map(item => ({ key: item.key, quantity: 0 }))

  if (updates.length == 0) return;

  var dataUpdate = { updates: {} };
  updates.forEach(update => dataUpdate.updates[update.key] = update.quantity)

  try {
    await $s.updateCartItemsQuantity(dataUpdate);
    $s.hideLoadingOverlay();
    const overlayHtml = `<div class="error-itemincart scheme">${lngg.cart__wear_dates__removed_items}</div>`
    if (window.SideCart) {
      window.SideCart.updateSideCart(false)
      $s.openModal(overlayHtml, 'message');
    } else {
      $s.openModal(overlayHtml, 'message', {
        close: () => {
          window.location.reload()
        }
      });
    }
  } catch (error) {
    $s.addToCartFail
  }


}
